module.exports = __webpack_public_path__ + "static/media/bigColorful.34888650.jpg";